import "~/misc/common";
import { p, loader, myGetNumValue } from "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import "~/misc/jstree";

export default class extends Controller {
  connect() {
    console.log('initManualSectionsIndex');
    var data = $('#toJs').data('tree');
    p(data);
    var editable = $('#toJs').data('editable');
    var current = $('#toJs').data('current');
    var plugins = ["themes", "contextmenu", "state"];
    if (editable) {
      plugins.push("dnd");
    }
    $('#jstree').jstree({
      "plugins": plugins,
      'core': {
        'data': data,
        "check_callback": true,
        'themes': {
          'variant': 'large'
        }
      },
      'contextmenu': {
        'items': {}
      },
      "state": {
        "key": "treeManualSectionsIndex"
      },
      "dnd": {
        "touch": false
      }
    }).on('state_ready.jstree', function () {
      $('#jstree').jstree(true).deselect_all();
      $('#jstree').jstree(true).select_node(current);
      $('#jstree').on("select_node.jstree", function (e, d) {
        p('select_node.jstree');
        loader(true);
        window.open('/manual_sections/' + d.node.id, '_self');
      });
      //$('#jstree').on("show_contextmenu.jstree", function(e, d) {
      //	p('show_contextmenu.jstree');
      //	window.open('/manual_sections/new?manual_section_id=' + d.node.id, '_self');
      //});
    });
    $('#jstree').on("move_node.jstree", function (e, d) {
      p('move_node.jstree');
      p(d);
      loader(true);
      $.ajax({
        url: '/manual_sections/' + d.node.id + '.json',
        type: 'PUT',
        data: {
          manual_section: {
            manual_section_id: myGetNumValue(d.parent),
            row_index: d.position
          }
        },
        success: function (result) {
          location.reload();
        },
        error: function (result) {
          p(result);
          alert(JSON.stringify(result.responseJSON.errors));
          location.reload();
        }
      });
    });
    $('#jstree').on("copy_node.jstree", function (e, d) {
      p('copy_node.jstree');
      p(e);
      p(d);
    });
    $('.copy').click(function () {
      navigator.clipboard.writeText($(this).data().txt);
    });
  }

  closeAll(e: Event) {
    $(e.currentTarget as HTMLButtonElement).blur();
    $('#jstree').jstree('close_all');
  }
  openAll(e: Event) {
    $(e.currentTarget as HTMLButtonElement).blur();
    $('#jstree').jstree('open_all');
  }
}